
import {get,post} from './http'
// 应用号登录
export const login = (params)=>{
  return post('/min-program//v1/min/login?code='+params.code+'&mobile='+params.mobile);
}
// 应用号登录
export const logout = (params)=>{
    return post('/min-program/v1/min/logout', params);
}
// 下单支付
export const mini_pay = (params)=>{
    return post('/min-program/v1/min/mini_pay', params);
}
// 支付结果通知
export const notify = (params)=>{
    return post('/min-program/v1/min/notify', params);
}
// 发送登录验证码
export const sendVerificationCode = (mobile)=>{
    return post('/min-program/v1/min/sendVerificationCode?mobile='+mobile);
}

